import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "$type", "children", "depth"];
import themes, { useDevDocsTheme } from 'developer-docs-shared-components/config/themes';
import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { useMemo, useState } from 'react';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const TocLink = _ref => {
  let {
      active: active,
      $type: type,
      children,
      depth
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [hover, setHover] = useState(false);
  const viewport = useViewport();
  const theme = useDevDocsTheme();
  const borderColor = useMemo(() => {
    if (theme.themeName === themes.PUBLIC.themeName) {
      return type !== 'category' && active ? 'fill-secondary-default' : 'border-tertiary-disabled';
    }
    if (!viewport.isMobile) {
      return 'border-tertiary-disabled';
    }
    return type !== 'category' && active ? 'fill-tertiary-hover' : 'border-tertiary-disabled';
  }, [viewport.isMobile, theme.themeName, type, active]);
  const typography = depth > 0 ? 'body-100' : 'body-125';
  const backgroundColor = useMemo(() => {
    // Hover should have precedence over active
    if (hover) {
      if (theme.themeName === themes.PUBLIC.themeName) {
        return type !== 'category' ? 'fill-secondary-subtle' : undefined;
      }
      return 'fill-tertiary-hover';
    }
    if (!viewport.isMobile) {
      if (theme.themeName === themes.PUBLIC.themeName) {
        return type !== 'category' && active ? 'fill-secondary-subtle' : undefined;
      }
      return type !== 'category' && active ? 'fill-tertiary-hover' : undefined;
    }
  }, [active, hover, theme.themeName, type, viewport.isMobile]);
  return /*#__PURE__*/_jsx(View, {
    paddingBlock: "100",
    paddingInline: "200",
    borderInlineStartColor: borderColor,
    backgroundColor: backgroundColor,
    borderInlineStartWidth: viewport.isMobile ? '0' : '300',
    borderInlineStartStyle: "solid",
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    marginBlockEnd: viewport.isMobile ? '600' : '0',
    children: /*#__PURE__*/_jsx(Link, Object.assign({
      color: "fill-surface-recessed"
    }, rest, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: typography,
        children: children
      })
    }))
  });
};